import React from 'react';
import { SpotlightTransition } from '@atlaskit/onboarding';
import withVariables from '../../controllers/engagement-template-with-variables';
import withEvents from '../../controllers/engagement-with-events';
import withMessage from '../../controllers/engagement-with-message';
import Spotlight from './main';
var SpotlightWithVariables = withVariables(Spotlight);
var SpotlightWithEvents = withEvents(SpotlightWithVariables);
export { Spotlight, SpotlightWithEvents };
var SpotlightWithMessage = withMessage(SpotlightWithEvents, 'spotlight');
export default function EngagementSpotlight(props) {
  return /*#__PURE__*/React.createElement(SpotlightTransition, null, /*#__PURE__*/React.createElement(SpotlightWithMessage, props));
}

// duplicate the export as a named one. That way, the export name in
// this entrypoint (defined in "af:exports") matches the name that is
// used in the main (src/index.ts) entrypoint.
export { EngagementSpotlight };